/** Labels en español para `customer_orders.cancel_reason`. */
const CANCEL_REASON_LABELS: Record<string, string> = {
  merchant: 'Rechazado por el local',
  customer: 'Cancelado por el cliente',
  unaccepted: 'No lo aceptaste a tiempo',
  reservation_expired: 'Reserva vencida',
  pickup_noshow: 'El cliente no retiró',
  matching_exhausted: 'No hubo repartidor',
  payment_expired: 'El cliente no completó el pago online',
};

export function formatCancelReasonLabel(reason: string | null | undefined): string {
  const key = reason?.trim();
  if (!key) return 'Sin motivo';
  return CANCEL_REASON_LABELS[key] ?? key;
}
